import { NativeStackNavigationProp, NativeStackScreenProps } from "@react-navigation/native-stack";
import type { CompositeScreenProps } from "@react-navigation/native";
import type { BottomTabScreenProps } from "@react-navigation/bottom-tabs";
import { Activity } from "./fragments";

// route types
export type RootStackParamList = {
  Activities: { tag: string } | undefined;
  Activity: { code: string };
  ActivityReviewList: undefined;
  ActivityReview: { id: string };
  ActivityRequestPoints: { code: string; id?: string };

  // My Activity
  MyActivity: { id: string; name?: string };
  MyActivityHistory: { plan?: string } | undefined;
  MyActivityManageRequest: { id: string };

  ComponentLibrary: undefined;
  Enroll: undefined;
  Main: undefined;
  DeferredComp: undefined;
  Login: undefined;
  Onboarding: undefined;
  Welcome: undefined;
  Account: undefined;
  AccountEditContact: undefined;
  EmailChange: undefined;
  SoftLanding: { memberType?: string };
  Consent: undefined;

  // Jobs
  JobPreferences: undefined;
  JobDetail: { id: string };
  JobApply: { id: string; companyName: string };
  JobApplySuccess: { companyName: string };

  // Events
  EventDetails: { slug: string };
  EventRegistration: { slug: string };
  EventConfirmation: { slug: string };
  EventTicket: { slug: string };

  // Dues
  Dues: { assignProxy: boolean } | undefined;
  DuesProxyPayment: { id: string };
};

export type ScreenProps<name extends keyof RootStackParamList> = NativeStackScreenProps<RootStackParamList, name, "root">;

export type RootStackScreenProps<T extends keyof RootStackParamList> = NativeStackScreenProps<RootStackParamList, T>;

export type MainTabParamList = {
  DeferredComp: undefined;
  Account: undefined;
  Home: undefined;
  Jobs: undefined;
};

export type MainTabScreenProps<T extends keyof MainTabParamList> = CompositeScreenProps<
  BottomTabScreenProps<MainTabParamList, T>,
  RootStackScreenProps<keyof RootStackParamList>
>;

declare global {
  namespace ReactNavigation {
    interface RootParamList extends RootStackParamList {}
  }
}

export type NavigationProps = NativeStackNavigationProp<RootStackParamList>;

interface Level {
  id: string;
  requirements: string;
  points: number;
}
export interface ActivityDetails extends Activity {
  description: string;
  participationLevels: [Level];
}

export interface Reviewer {
  id: string;
  name: string;
  firstName: string | null;
  lastName: string | null;
  profilePhoto?: string;
  location?: string;
}

export enum SubmissionStatus {
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum EligibilityStatus {
  NON_COACH = "NON_COACH",
  NON_MEMBER = "NON_MEMBER",
  INELIGIBLE_CLASS = "INELIGIBLE_CLASS",
  INACTIVE = "INACTIVE",
  EMPLOYEE = "EMPLOYEE",
  ELIGIBLE = "ELIGIBLE",
}
